import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays variant-specific "included" text from metafields.
 * This component listens for variant update events and updates the text display accordingly.
 */
class VariantIncludedText extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateText);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateText);
  }

  /**
   * Updates the included text when variant changes.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateText = (event) => {
    // Handle combined listings (different products)
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the new text content from the fetched HTML
    const newTextElement = event.detail.data.html.querySelector('variant-included-text [ref="includedContent"]');
    const currentTextElement = this.querySelector('[ref="includedContent"]');

    if (!newTextElement || !currentTextElement) return;

    // Only update if content has changed
    if (currentTextElement.innerHTML !== newTextElement.innerHTML) {
      morph(currentTextElement, newTextElement);
    }
  };
}

if (!customElements.get('variant-included-text')) {
  customElements.define('variant-included-text', VariantIncludedText);
}
